import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { push } from 'redux-first-history';
import { useTranslation } from 'react-i18next';
import { ResetPassword } from '@dev/ee-modules';
import { ProductCode } from '@dev/ee-api/ee-api-models';

import { useMobile } from '@api/services/hooks/useMobile';

import { ApplicationState } from '../../store';
import { SetNewPassword, ShowNewPasswordScreen } from '../../store/session/actions';

const ResetPasswordForm: FC = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const location = useLocation();
    const isMobile = useMobile();
    const session = useSelector((store: ApplicationState) => store.session);
    return (
        <ResetPassword
            session={session}
            location={location}
            productCode={ProductCode.EmailApi}
            SetNewPassword={(password: string, token: string) => dispatch(SetNewPassword(password, token))}
            Push={(url: string) => dispatch(push(url))}
            ShowNewPasswordScreen={() => dispatch(ShowNewPasswordScreen())}
            t={t}
            isMobile={isMobile}
        />
    );
};

export default ResetPasswordForm;
